import { FileUp, FileText } from "lucide-react";
import { http } from "../../lib/api";

export const uploadChunks = async (file, body, onProgress) => {
  const { data } = await http.post("/imports/start", { ...body, filename: file.name, size: file.size });
  const n = Math.ceil(file.size / data.chunk_size);
  for (let i = 0; i < n; i++) {
    const blob = file.slice(i * data.chunk_size, (i + 1) * data.chunk_size);
    for (let t = 0; ; t++) {
      try { await http.put(`/imports/${data.id}/chunk/${i}`, blob, { headers: { "Content-Type": "application/octet-stream" } }); break; }
      catch (e) { if (t >= 3) throw e; await new Promise((r) => setTimeout(r, 1500 * (t + 1))); }
    }
    onProgress(Math.round(((i + 1) / n) * 100));
  }
  return data.id;
};

export const uploadPdf = async (file, onProgress, queue = false, kind = {}) => {
  const id = await uploadChunks(file, { bulk: true }, onProgress);
  return (await http.post(`/imports/${id}/auto`, { queue, ...kind })).data;
};

export const PdfPicker = ({ file, setFile, progress }) => (
  <div className="mb-10">
    <label data-testid="import-pdf-dropzone" className="flex items-center gap-4 rounded-xl border-2 border-dashed border-[#C9A847]/60 bg-[#FBF8F0] p-6 cursor-pointer hover:bg-[#F6F0E0] transition-colors">
      {file ? <FileText size={28} className="text-[#9A7B2C]" /> : <FileUp size={28} className="text-[#9A7B2C]" />}
      <div className="flex-1">
        <div data-testid="import-pdf-filename" className="font-display text-xl text-[#2B2A26]">{file ? file.name : "Choose your kit PDF or HTML file"}</div>
        <div className="text-xs text-stone-500 mt-1">{file ? `${(file.size / 1048576).toFixed(1)} MB` : "PDF or saved .html (e.g. an old interactive kit app) · up to 600 MB"}</div>
      </div>
      <input data-testid="import-pdf-input" type="file" accept="application/pdf,.pdf,text/html,.html,.htm" className="hidden" onChange={(e) => setFile(e.target.files?.[0] || null)} />
    </label>
    {progress != null && (
      <div className="mt-3" data-testid="import-upload-progress">
        <div className="h-2 rounded-full bg-stone-200 overflow-hidden"><div className="h-full bg-[#C9A847] transition-[width] duration-300" style={{ width: `${progress}%` }} /></div>
        <div className="text-xs text-stone-500 mt-1">Uploading… {progress}%</div>
      </div>
    )}
    <p className="text-xs text-stone-500 mt-3 max-w-2xl">Just upload — the destination, Edition, tier, days and season are read from the file for you (change any of them later). Your wording is kept; spelling and link fixes are applied automatically, and only changed facts or replaced venues wait for your approval.</p>
  </div>
);
